export default {
  name: 'Video Navigation'
}
